export default __webpack_public_path__ + "static/media/map.8d5541de.png";